import React from 'react';
import { FormattedMessage } from 'react-intl';
import * as mobxReact from 'mobx-react';

interface IPopoverData {
    attendeeName: string;
    attendeeIssues: string;
    attendeeStatus: string;
    attendeeNote: string;
    attendeeId: number;
}

interface IProps {
    popoverData: IPopoverData[];
    operatorMeetingNotes: string;
}

const MeetingBadgeContent = mobxReact.observer((props: IProps) => {
    const {popoverData, operatorMeetingNotes} = props;
    return (
        <>
            {popoverData.map(attendee => {
                return <div className='meeting-status-column__attendee-item' key={attendee.attendeeId}>
                    <div className='meeting-status-column__attendee-name'>{attendee.attendeeName}
                        {attendee.attendeeIssues ?
                            <span className='meeting-status-column__attendee-issues'>: {attendee.attendeeIssues}</span>
                            : attendee.attendeeStatus && <span className='meeting-status-column__attendee-status'>: {attendee.attendeeStatus}</span>
                        }
                    </div>
                    <div className='meeting-status-column__attendee-note'>{attendee.attendeeNote}</div>
                </div>;
            })}
            {operatorMeetingNotes ? <div className='meeting-status-column__meeting-note'>
                <div className='meeting-status-column__meeting-note-title'>
                    <FormattedMessage
                        id='oe.meeting.notes'
                        description='Header text'
                        defaultMessage='Meeting Notes'
                    />
                </div>
                <div>{operatorMeetingNotes}</div>
            </div> : null}
        </>
    );
});

export default MeetingBadgeContent;